
import { TypedVue } from "@/store/types";
import { Component, Inject, Prop } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import { classifyCompetencies, CompetencyStat, LeaderSummary, PRIORITY_ORDER, PRIORITY_LEVELS, SummaryClassification } from "./shared";

@Component
export default class SummaryTab extends TypedVue {
  @Inject("$i18n") readonly $i18n!: VueI18n;

  @Prop({ required: true }) readonly stats!: CompetencyStat[];
  @Prop({ required: true }) readonly leaders!: LeaderSummary[];
  @Prop({ required: true }) readonly traitPriorities!: { [trait: string]: 0 | 1 | 2 };

  get zones() {
    return PRIORITY_ORDER.map((key) => ({ key, stats: this.stats.filter((s) => s.level === PRIORITY_LEVELS[key]) }));
  }

  get classification(): SummaryClassification {
    return classifyCompetencies(this.stats);
  }

  get watchGroups() {
    return [
      { key: "ImportantLow", items: this.classification.watchUnder },
      { key: "SupportingHigh", items: this.classification.watchOver },
      { key: "WideSpread", items: this.classification.watchSplit },
    ];
  }

  get watchTotal(): number {
    return this.classification.watchUnder.length + this.classification.watchOver.length + this.classification.watchSplit.length;
  }

  countLabel(n: number): string {
    return this.$t(n === 1 ? "Summary::Count::One" : "Summary::Count::Many", { n }).toString();
  }

  orientationLabel(c: CompetencyStat): string {
    return this.$t(`Orientation::${c.orientationId}::Label`).toString();
  }
}
